import React from "react";
import { CheckIcon, FileTextIcon, MailIcon, XIcon } from "lucide-react";
const notIncluded = ["Pas de vidéos", "Pas d'audios", "Pas de cours collectifs"];
export function FormatNotice() {
  return <div className="mt-10 grid overflow-hidden rounded-2xl border border-brass/40 md:grid-cols-[1.2fr_1fr]" data-id="element-96" data-mp="25ei9v02qefap">
      <div className="bg-ebony p-8" data-id="element-97" data-mp="2aduv5gdyfeb6">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-brass" data-id="element-98" data-mp="2aexl9m3gdcq1">
          Important · Format du contenu
        </p>
        <h3 className="mt-3 font-display text-3xl uppercase leading-none text-linen md:text-4xl" data-id="element-99" data-mp="324iucmw2i9m7">
          Un contenu 100 % PDF
        </h3>
        <p className="mt-4 leading-relaxed text-sand/80" data-id="element-100" data-mp="2oc2yq75hxdvb">
          Le pack est exclusivement composé de fichiers PDF à télécharger, imprimer et utiliser
          dans vos cours.
        </p>
        <ul className="mt-6 flex flex-wrap gap-3" data-id="element-101" data-mp="3h0i21wf9m7qt">
          {notIncluded.map(item => <li key={item} className="flex items-center gap-2 rounded-full border border-linen/15 px-4 py-2 text-sm text-linen" data-id="element-102" data-mp="3lsrxtt32a210">
              <XIcon className="h-4 w-4 text-brass" aria-hidden="true" data-id="element-103" data-mp="2duigjx2u0u5w" />
              {item}
            </li>)}
        </ul>
      </div>
      <ul className="flex flex-col justify-center gap-6 bg-linen p-8" data-id="element-104" data-mp="2rmyfomsm481j">
        <li className="flex gap-4" data-id="element-105" data-mp="2mtm1l6lk7jn1">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-walnut" data-id="element-106" data-mp="2mtc653hqwk9y">
            <FileTextIcon className="h-5 w-5 text-linen" aria-hidden="true" data-id="element-107" data-mp="31lnug6p7pcdk" />
          </span>
          <div data-id="element-108" data-mp="2wmkpsnd59864">
            <p className="font-semibold text-ink" data-id="element-109" data-mp="2wmt6kqce0xml">Fichiers PDF uniquement</p>
            <p className="text-sm text-stone" data-id="element-110" data-mp="3ajgajd2rco20">Lisibles sur ordinateur, tablette ou papier.</p>
          </div>
        </li>
        <li className="flex gap-4" data-id="element-111" data-mp="35jbrbfagtf83">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-walnut" data-id="element-112" data-mp="1g5f529cpd2sy">
            <MailIcon className="h-5 w-5 text-linen" aria-hidden="true" data-id="element-113" data-mp="1b86vuy9j893u" />
          </span>
          <div data-id="element-114" data-mp="3ba6eouzoryfi">
            <p className="font-semibold text-ink" data-id="element-115" data-mp="3baoj4ewi5iyi">Reçu immédiatement par e-mail</p>
            <p className="text-sm text-stone" data-id="element-116" data-mp="3g7offy3jv7cf">Dès la confirmation de votre paiement.</p>
          </div>
        </li>
        <li className="flex items-center gap-2 text-sm font-medium text-walnut" data-id="element-117" data-mp="3l6rjpgbph9jc">
          <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-118" data-mp="3p9ef1r7l5cla" />
          Sans abonnement, à vous pour toujours
        </li>
      </ul>
    </div>;
}